import React from "react";

import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { Button } from "@mui/material";
import img from "../../../assets/images/correspondente-cambial.png"
export default function PoliticaCorrespondenteCambial() {
  return (
    <article className="art-s mb-5 p-text">
      <section className="row m-0  sectionInit ">
        <div className="c-init  ">
          <div className="c-init__text col-6  d-flex flex-column sect">
            <p className="fw-bolder text-decoration-underline text-uppercase">
              POLÍTICA DE CORRESPONDENTES CAMBIAIS
            </p>

            <p>
              Política elaborada por Marco Dulgheroff Novais (Jurídico) e
              autorizada a publicação pelo Diretor Elson do Nascimento Nunes
              Gusmão, para instrução e adequação dos procedimentos da OM DTVM à
              necessária prevenção e repressão de infrações administrativas e
              legais.
            </p>
          </div>
          <div className="col-6 c-init__images">
            <img src={img} className="images" alt="politica-privacidade"></img>
          </div>
        </div>

        <section>
          <h3>Sumário</h3>
          <ol>
            <li>
              <a href="#sec1">Conformidade e Âmbito de Aplicação</a>
            </li>
            <li>
              <a href="#sec2">Validade e Disponibilização</a>
            </li>
            <li>
              <a href="#sec3">Objetivo deste Procedimento</a>
            </li>
            <li>
              <a href="#sec4">Programa de Prevenção à Lavagem de Dinheiro</a>
            </li>
            <li>
              <a href="#sec5">Dos Princípios</a>
            </li>
            <li>
              <a href="#sec6">Das Diretrizes</a>
            </li>
            <li>
              <a href="#sec7">Papéis e Responsabilidades</a>
            </li>
            <li>
              <a href="#sec8">Definição de Correspondente Cambial</a>
            </li>
            <li>
              <a href="#sec9">Tipos e Funções de Correspondente Cambial</a>
            </li>
            <li>
              <a href="#sec10">
                Procedimento Pré-Contratação do Correspondente Cambial
              </a>
            </li>
            <li>
              <a href="#sec11">Contrato com o Correspondente Cambial</a>
            </li>
            <li>
              <a href="#sec12">
                Acompanhamento da Atividade Negocial do Correspondente
              </a>
            </li>
            <li>
              <a href="#sec13">
                Risco Operacional e Reanálise Reputacional do Correspondente
                Cambial
              </a>
            </li>
            <li>
              <a href="#sec14">Guarda de Documentos</a>
            </li>
            <li>
              <a href="#sec15">Sanções Administrativas</a>
            </li>
          </ol>
        </section>

        <section className="mt-5 border p-5" id="sec1">
          <p>
            <ul>
              <li className="fw-bolder text-decoration-underline text-uppercase  mb-3 list-unstyled">
                1. Conformidade e Âmbito de Aplicação
              </li>
              <li className="list-unstyled">
                <p>
                  A Política de Correspondentes Cambiais, a ser apresentada,
                  está em conformidade com a Resolução CMN nº 4.935/21
                  <CustomTooltip
                    text="Dispõe sobre a possibilidade de Instituições Financeiras realizarem contratação de Correspondentes para o desenvolvimento de sua atividade operacional. A referida Resolução apresenta a devida parametrização regulatória necessária para o início, manutenção e encerramento de relacionamento de Instituições Financeiras com Correspondentes."
                    title="¹"
                  />{" "}
                  Lei nº 9.613/98{" "}
                  <CustomTooltip
                    title="²"
                    text='Dispõe sobre os crimes de "lavagem" ou ocultação de bens, direitos e valores; a prevenção da utilização do sistema financeiro para os ilícitos previstos nesta Lei; cria o Conselho de Controle de Atividades Financeiras - COAF, e dá outras providências.'
                  />
                  , Lei nº 12.683/12{" "}
                  <CustomTooltip
                    title="³"
                    text="Altera a Lei nº 9.613, de 3 de março de 1998, para tornar mais eficiente a persecução penal dos crimes de lavagem de dinheiro."
                  />
                  ; Lei nº 12.844/13{" "}
                  <CustomTooltip
                    title="⁴"
                    text="Amplia o valor do Benefício Garantia-Safra para a safra de 2011/2012; amplia o Auxílio Emergencial Financeiro, de que trata a Lei nº 10.954, de 29 de setembro de 2004, relativo aos desastres ocorridos em 2012; autoriza a distribuição de milho para venda a pequenos criadores, nos termos que especifica; institui medidas de estímulo à liquidação ou regularização de dívidas originárias de operações de crédito rural; altera as Leis nºs 10.865, de 30 de abril de 2004, e 12.546, de 14 de dezembro de 2011, para prorrogar o Regime Especial de Reintegração de Valores Tributários para as Empresas Exportadoras - REINTEGRA e para alterar o regime de desoneração da folha de pagamentos, 11.774, de 17 de setembro de 2008, 10.931, de 2 de agosto de 2004, 12.431, de 24 de junho de 2011, 12.249, de 11 de junho de 2010, 9.430, de 27 de dezembro de 1996, 10.522, de 19 de julho de 2002, 8.218, de 29 de agosto de 1991, 10.833, de 29 de dezembro de 2003, 9.393, de 19 de dezembro de 1996, 12.783, de 11 de janeiro de 2013, 12.715, de 17 de setembro de 2012, 11.727, de 23 de junho de 2008, 12.468, de 26 de agosto de 2011, 10.150, de 21 de dezembro de 2000, 12.512, de 14 de outubro de 2011, 9.718, de 27 de novembro de 1998, 10.925, de 23 de julho de 2004, 11.775, de 17 de setembro de 2008, e 12.716, de 21 de setembro de 2012, a Medida Provisória nº 2.158-35, de 24 de agosto de 2001, e o Decreto nº 70.235, de 6 de março de 1972; dispõe sobre a comprovação de regularidade fiscal pelo contribuinte; regula a compra, venda e transporte de ouro; e dá outras providências."
                  />
                  ; Lei nº 13.260/16{" "}
                  <CustomTooltip
                    title="⁵"
                    text="Amplia o valor do Benefício Garantia-Safra para a safra de 2011/2012; amplia o Auxílio Emergencial Financeiro, de que trata a Lei nº 10.954, de 29 de setembro de 2004, relativo aos desastres ocorridos em 2012; autoriza a distribuição de milho para venda a pequenos criadores, nos termos que especifica; institui medidas de estímulo à liquidação ou regularização de dívidas originárias de operações de crédito rural; altera as Leis nºs 10.865, de 30 de abril de 2004, e 12.546, de 14 de dezembro de 2011, para prorrogar o Regime Especial de Reintegração de Valores Tributários para as Empresas Exportadoras - REINTEGRA e para alterar o regime de desoneração da folha de pagamentos, 11.774, de 17 de setembro de 2008, 10.931, de 2 de agosto de 2004, 12.431, de 24 de junho de 2011, 12.249, de 11 de junho de 2010, 9.430, de 27 de dezembro de 1996, 10.522, de 19 de julho de 2002, 8.218, de 29 de agosto de 1991, 10.833, de 29 de dezembro de 2003, 9.393, de 19 de dezembro de 1996, 12.783, de 11 de janeiro de 2013, 12.715, de 17 de setembro de 2012, 11.727, de 23 de junho de 2008, 12.468, de 26 de agosto de 2011, 10.150, de 21 de dezembro de 2000, 12.512, de 14 de outubro de 2011, 9.718, de 27 de novembro de 1998, 10.925, de 23 de julho de 2004, 11.775, de 17 de setembro de 2008, e 12.716, de 21 de setembro de 2012, a Medida Provisória nº 2.158-35, de 24 de agosto de 2001, e o Decreto nº 70.235, de 6 de março de 1972; dispõe sobre a comprovação de regularidade fiscal pelo contribuinte; regula a compra, venda e transporte de ouro; e dá outras providências."
                  />
                  ; Lei nº 13.810/19{" "}
                  <CustomTooltip
                    title="⁶"
                    text="Dispõe sobre o cumprimento de sanções impostas por resoluções do Conselho de Segurança das Nações Unidas, incluída a indisponibilidade de ativos de pessoas naturais e jurídicas e de entidades, e a designação nacional de pessoas investigadas ou acusadas de terrorismo, de seu financiamento ou de atos a ele correlacionados; e revoga a Lei nº 13.170, de 16 de outubro de 2015."
                  />
                  ; Circular BCB nº 3.978/20{" "}
                  <CustomTooltip
                    title="⁷"
                    text="Dispõe sobre a política, os procedimentos e os controles internos a serem adotados pelas instituições autorizadas a funcionar pelo Banco Central do Brasil visando à prevenção da utilização do sistema financeiro para a prática dos crimes de “lavagem” ou ocultação de bens, direitos e valores, de que trata a Lei nº 9.613, de 3 de março de 1998, e de financiamento do terrorismo, previsto na Lei nº 13.260, de 16 de março de 2016."
                  />
                  ; Carta Circular BCB nº 4.001/20{" "}
                  <CustomTooltip
                    title="⁸"
                    text=' Divulga relação de operações e situações que podem configurar indícios de ocorrência dos crimes de "lavagem" ou ocultação de bens, direitos e valores, de que trata a Lei nº 9.613, de 3 de março de 1998, e de financiamento ao terrorismo, previstos na Lei nº 13.260, de 16 de março de 2016, passíveis de comunicação ao Conselho de Controle de Atividades Financeiras (Coaf).'
                  />
                  ; Resolução CMN nº 4.968/21{" "}
                  <CustomTooltip
                    title="⁹"
                    text="Dispõe sobre os sistemas de controles internos das instituições financeiras e demais instituições autorizadas a funcionar pelo Banco Central do Brasil."
                  />{" "}
                  ; Resolução BCB nº 44/20{" "}
                  <CustomTooltip
                    text="Estabelece procedimentos para a execução pelas instituições autorizadas a funcionar pelo Banco Central do Brasil das medidas determinadas pela Lei nº 13.810, de 8 de março de 2019, que dispõe sobre o cumprimento de sanções impostas por resoluções do Conselho de Segurança das Nações Unidas, incluída a indisponibilidade de ativos de pessoas naturais e jurídicas e de entidades, e a designação nacional de pessoas investigadas ou acusadas de terrorismo, de seu financiamento ou de atos a ele correlacionados."
                    title="¹⁰"
                  />
                  , Instrução Normativa BCB nº 262/2211.
                </p>
              </li>
            </ul>
          </p>
        </section>

        <section className="mt-5 border p-5" id="sec2">
          <ul>
            <li className="fw-bolder text-decoration-underline text-uppercase mb-3 list-unstyled">
              2. Validade e Disponibilização
            </li>
          </ul>
          <p>
            AA gestão desta Política (elaboração, conformidade, guarda,
            divulgação, controle de atualizações e adesão) origina-se do
            Programa de Compliance da <b>OM DTVM</b>, de modo que seu conteúdo e
            implementação é de responsabilidade do Diretor da <b>OM DTVM,</b>{" "}
            Elson do Nascimento Nunes Gusmão.
          </p>
          <p>
            Esta política será reavaliada e republicada anualmente, bem como na
            hipótese de quaisquer alterações na <b>OM DTVM</b> ou em razão de
            requerimentos legais, regulatórios e/ou administrativos que
            justifiquem a antecipação.
          </p>
        </section>
        <section className="mt-5 border p-5" id="sec3">
          <ul>
            <li className="fw-bolder text-decoration-underline text-uppercase mb-3 list-unstyled">
              3. Objetivo deste Procedimento
            </li>
          </ul>
          <p>
            Implementar procedimentos destinados ao início, manutenção e
            eventual encerramento do relacionamento da <b>OM DTVM</b> com
            Correspondentes Cambiais, incluindo aqueles que assegurem a devida
            diligência em sua identificação, qualificação e classificação, em
            consonância àquilo orientado pelo Banco Central do Brasil por meio
            dos artigos 9º, 10, 13, 14 e 15, todos da Resolução nº 3.954/11.
          </p>
        </section>
        <section className="mt-5 border p-5" id="sec4">
          <ul>
            <li className="fw-bolder text-decoration-underline text-uppercase mb-3 list-unstyled">
              4. Programa de Prevenção à Lavagem de Dinheiro
            </li>
          </ul>
          <p>
            O Programa de Prevenção à Lavagem de Dinheiro e Financiamento ao
            Terrorismo da <b>OM DTVM</b> é essencialmente constituído por 06
            (seis) pilares:
          </p>
          <p>
            <b>(i)</b> Política de Prevenção à Lavagem de Dinheiro e
            Financiamento ao Terrorismo;
          </p>
          <p>
            <b>(ii)</b> Avaliação Interna de Riscos;
          </p>
          <p>
            <b>(iii)</b> Manuais de Procedimentos Operacionais;
          </p>
          <p>
            <b>(iv)</b> Avaliação da Efetividade;
          </p>
          <p>
            <b>(v)</b> Treinamento de Prevenção à Lavagem de Dinheiro e
            Financiamento ao Terrorismo;
          </p>
          <p>
            <b>(vi)</b> Auditoria Interna.
          </p>
          <p>
            Os retromencionados pilares estão em estrita compatibilidade tanto
            às determinações administrativas e legais, quanto à natureza, porte,
            complexidade, estrutura, perfil de risco e modelo de negócio da{" "}
            <b>OM DTVM.</b>
          </p>
          <p>
            Em assim sendo, o Programa de Prevenção à Lavagem de Dinheiro
            (“PLD”), como explorar-se-á adiante, é lastreado em princípios e
            diretrizes que buscam prevenir, mitigar e reprimir os riscos
            relacionados à operação desenvolvida pela <b>OM DTVM</b> e seus
            Correspondentes Cambiais.
          </p>
        </section>

        <section className="mt-5 border p-5" id="sec5">
          <ul>
            <li className="fw-bolder text-decoration-underline text-uppercase mb-3 list-unstyled">
              5. Dos Princípios
            </li>
          </ul>
          <p>
            A <b>OM DTVM</b> em sua atuação, busca viabilizar a coibição de
            riscos ao Sistema Financeiro Nacional, bem como coadunar seus
            Correspondentes Cambiais à melhor diligência no processo de
            Prevenção à Lavagem de Dinheiro, Financiamento ao Terrorismo e
            Proliferação de Armas de Destruição em Massa (PLD-FTP).
          </p>
          <p>
            Neste sentido a <b>OM DTVM</b> está empenhada em conduzir os seus
            negócios de forma consistente com os mais elevados padrões éticos e
            em conformidade com todas as leis, regulamentos e normas vigentes e
            aplicáveis, promovendo uma cultura organizacional que repudia
            qualquer ação que possa implicar em LD-FT.
          </p>
          <p>
            Em razão disso, a OM DTVM profundamente estatuiu a vedação de sua
            associação e/ou utilização de sua operação como meio de viabilizar
            e/ou facilitar tais atos, realizando, a tal título, extensa
            checagem, gerenciamento e repressão aos riscos suscetíveis ao âmbito
            de sua operação no mercado de câmbio.
          </p>
          <p>
            A identificação de qualquer indício de Lavagem de Dinheiro e
            Financiamento ao Terrorismo ou qualquer outro ato ilícito, é
            imediatamente comunicada à área de Compliance, que será responsável
            por averiguar as informações reportadas e, no evento de serem
            constatadas, imediatamente comunicar aos órgãos reguladores.
          </p>
          <p>
            A <b>OM DTVM</b> também disponibiliza, em sua rede interna (Intranet
            ou Microsoft Teams), um Canal de Denúncias, o qual é destinado ao
            recebimento anônimo de denúncias de eventual perpetração de atos
            indevidos, especialmente com relação à Lavagem de Dinheiro,
            Financiamento ao Terrorismo e/ou Proliferação de Armas de Destruição
            em Massa.
          </p>
        </section>
        <section className="mt-5 border p-5" id="sec6">
          <ul>
            <li className="fw-bolder text-decoration-underline text-uppercase mb-3 list-unstyled">
              6. Das Diretrizes
            </li>
          </ul>
          <p>
            A Diretoria da <b>OM DTVM</b> em seu extenso compromisso de
            aprimorar os controles internos e estabelecer as diretrizes para o
            contínuo fortalecimento das práticas de prevenção de ilícitos,
            definiu 09 (nove) principais diretrizes, as quais estão sendo
            amplamente aplicadas no âmbito da operação da <b>OM DTVM</b>:
          </p>
          <ul>
            <li></li>
            <li>
              Proteção à reputação e imagem da <b>OM DTVM</b> através da
              proibição de realização de operações maculadas por indícios de
              crimes de lavagem ou ocultação de bens, direitos e valores, de
              financiamento do terrorismo e/ou proliferação de armas de
              destruição em massa;
            </li>
            <li>
              Desenvolvimento e implementação de políticas, procedimentos e
              controles internos que promovam a efetiva participação da
              comunidade interna em prevenir o uso de produtos e serviços da{" "}
              <b>OM DTVM</b> para a lavagem de dinheiro e financiamento ao
              terrorismo, contribuindo, por assim, para engendrar e enraizar uma
              cultura organizacional de PLD-FT;
            </li>
            <li>
              Estritar os procedimentos inerentes à identificação, qualificação
              e monitoramento de todos os participantes de sua operação de
              câmbio ou ouro, para o fim de verificar eventual inscrição destes
              perante a lista restritiva do Conselho de Segurança das Nações
              Unidas (CSNU), a qual é constituída por pessoas físicas e/ou
              jurídicas envolvidas em atos ou financiamento de entidades
              terroristas;
            </li>
            <li>
              Fornecimento de treinamento adequado e periódico aos funcionários
              e colaboradores de todos os níveis da
              <b>OM DTVM,</b> especialmente àqueles cujo ramo de atuação gera
              exposição à operações maculadas pelo risco de viabilização de
              atividade ilícita;
            </li>
            <li>
              Avaliação prévia de todos os novos produtos e serviços, bem como o
              emprego de novas tecnologias, para o específico fim de reprimir
              qualquer possibilidade de associação à atividades ilícitas e/ou
              antiéticas;
            </li>
            <li>
              Monitoramento sistêmico de operações visando a lisura das
              operações, bem como da repressão e imediata reprovação/cessação da
              operação em sendo identificados indícios de lavagem de dinheiro e
              financiamento ao terrorismo em consonância com a “Abordagem
              Baseada em Risco” do GAFI;
            </li>
            <li>
              Realização de auditoria interna anual para a verificação da
              aderência e da adequação das políticas, procedimentos e controles
              internos de PLD-FT;
            </li>
            <li>
              Designação, ao Banco Central do Brasil, de diretor responsável
              pela implementação e cumprimento das medidas relacionadas a
              PLD-FT, o qual ficará encarregado de gerenciar e supervisionar a
              aplicação das normas vigentes e dos princípios e diretrizes aqui
              estabelecidos;
            </li>
            <li>
              Condução, de forma sigilosa, dos processos de registro, análise e
              comunicação às autoridades competentes de operações financeiras
              com indícios de lavagem de dinheiro.
            </li>
          </ul>
        </section>

        <section className="mt-5 border p-5" id="sec7">
          <ul>
            <li className="fw-bolder text-decoration-underline text-uppercase mb-3 list-unstyled">
              7. Papéis e Responsabilidades
            </li>

            <li>
              <b>DIRETORIA:</b> Responsável por aprovar as diretrizes do Manual
              de Conheça seu Cliente (KYC) e suas respectivas alterações,
              zelando pela devida implementação dos procedimentos e controles
              regulamentados pela legislação em vigor e, assegurar a adoção de
              melhorias corretivas e preventivas para garantir a efetividade do
              presente Manual.
            </li>
            <li>
              COMPLIANCE:<b></b> Aprovar o início da relação de negócios em caso
              de insuficiência de informações relativas ao processo de
              qualificação, desde que não haja prejuízo aos procedimentos de
              monitoramento e seleção, bem como aprovar a manutenção de Pessoa
              Exposta Politicamente (PEP) e agentes inseridos em monitoramento
              de especial atenção e, avaliação da continuidade do relacionamento
              relacionada ao descumprimento de condições originalmente pactuadas
              identificadas no processo de monitoramento. Responsável pela
              elaboração, conformidade, guarda, divulgação, controle de
              atualizações, adesão e promoção da cultura organizacional de
              prevenção à lavagem de dinheiro e financiamento ao terrorismo;
              gerenciamento do sistema de normativo interno relacionado à
              Compliance e Controles Internos tais como: avaliação interna de
              risco (AIR), políticas, procedimentos, diretrizes, normas e
              manuais, instruções normativas e recomendações institucionais para
              conformidade do negócio; aderência da instituição ao arcabouço
              legal, à regulamentação infralegal, às recomendações dos órgãos de
              supervisão e aos códigos de ética e de conduta, bem como prestar
              suporte a Diretoria Executiva em assuntos relativos à Governança,
              Risco e Compliance – GRC; atender as demandas e eventuais
              auditorias de órgãos reguladores; análise de situações reportados
              pela comunidade interna e canal de denúncia e, realizar os
              procedimentos relacionados a indisponibilidade de ativos
              estabelecida nas Resoluções do CSNU como: determinação a execução
              de bloqueio dos ativos (indisponibilidade para transferir,
              converter, trasladar, disponibilizar os ativos ou deles dispor) de
              titularidade de cliente pessoa física ou jurídica identificada
              como sancionada pelo Conselho de Segurança das Nações Unidas e,
              comunicação ao Banco Central do Brasil, ao Ministério da Justiça e
              Segurança Pública e ao Conselho de Controle de Atividade
              Financeira (COAF) dessa indisponibilidade de ativos ou das
              tentativas de sua transferência, conforme disposto no artigo 4º da
              Resolução BCB nº 44{" "}
              <CustomTooltip
                title="¹²"
                text="Estabelece procedimentos para a execução pelas instituições autorizadas a funcionar pelo Banco Central do Brasil das medidas determinadas pela Lei nº 13.810, de 8 de março de 2019, que dispõe sobre o cumprimento de sanções impostas por resoluções do Conselho de Segurança das Nações Unidas, incluída a indisponibilidade de ativos de pessoas naturais e jurídicas e de entidades, e a designação nacional de pessoas investigadas ou acusadas de terrorismo, de seu financiamento ou de atos a ele correlacionados."
              />{" "}
              de 24 de novembro de 2020.
            </li>
            <li>
              <b>AUDITORIA INTERNA:</b> Responsável por avaliar e propor medidas
              para aprimoramento e efetividade do Manual: Conheça Seu Cliente
              (KYC) e processos que a <b>OM DTVM</b> estabelece, sempre
              verificando a aderência as regulamentações em vigor e
              aplicabilidade fática.
            </li>
            <li>
              <b>PLD-FT:</b> Responsável pelo monitoramento tempestivo de
              clientes e operações, mediante a avaliação da capacidade econômico
              financeira visando coerência nos negócios realizados e indícios de
              lavagem de dinheiro e financiamento ao terrorismo; implementar
              processos e procedimentos para identificação, monitoramento e
              análise de comportamentos, operações e/ou transações suspeitas de
              lavagem de dinheiro e financiamento ao terrorismo; reportar ao
              Diretor de Compliance ou Comitê Executivo comportamentos,
              operações e/ou transações suspeitas para deliberação; reportar ao
              COAF/UIF, após a devida deliberação, suspeitas de lavagem de
              dinheiro e financiamento ao terrorismo; realizar diligências
              sempre que necessário em clientes, fornecedores e/ou parceiros;
              inclusão de clientes em monitoramento de especial atenção.
            </li>
            <li>
              <b>ONBOARDING & BACKGROUND CHECK (CADASTRO):</b> Cumprir as normas
              internas e regulamentos vigentes quanto à Avaliação Interna de
              Riscos (AIR) relacionado aos processos de identificação,
              qualificação e classificação dos procedimentos de KYC, KYP, KYE e
              KYS; definir procedimentos para identificação, qualificação e
              obtenção de dados cadastrais visando a identificação e
              conhecimento do cliente bem como garantir o atendimento
              regulatório; definir controles para validação dos dados cadastrais
              declarados pelos clientes; Garantir que o cadastro do cliente
              esteja em conformidade com o status da Receita Federal;
              Identificar o Beneficiário Final dos clientes Pessoa Jurídica e,
              identificar clientes Pessoas Expostas Politicamente (PEP),
              clientes em listas restritivas, clientes que residem em região de
              fronteira ou possuem nacionalidade em país considerado sensível
              para fins de PLD-FT, ou que apresentam enquadramento em profissão
              de risco ou atividades de risco, que seguem procedimento
              particular com a efetivação do processo apenas após autorização
              explicita do Diretor de Compliance.
            </li>
            <li>
              <b>TECNOLOGIA DA INFORMAÇÃO (T.I.):</b> Garantir o funcionamento
              dos sistemas do Correspondente.
            </li>
          </ul>
        </section>
        <section className="mt-5 border p-5" id="sec8">
          <ul>
            <li className="fw-bolder text-decoration-underline text-uppercase mb-3 list-unstyled">
              8. Definição de Correspondente Cambial
            </li>
          </ul>
          <p>
            Consonante artigo 2º, da Resolução CMN nº 4.935/21
            <CustomTooltip
              title="¹³"
              text="As instituições financeiras e demais instituições autorizadas a funcionar pelo Banco Central do Brasil devem observar as disposições desta Resolução como condição para a contratação de correspondentes no País, visando à prestação de serviços, pelo contratado, de atividades de atendimento a clientes e usuários da instituição contratante. § 1º A prestação de serviços de que trata esta Resolução, de forma pessoal ou por meio de plataforma eletrônica, somente pode ser contratada com correspondente no País.
§ 2º Considera-se plataforma eletrônica sistema eletrônico operado pelo correspondente no País, que permite a realização das atividades de atendimento de que trata o art. 12 desta Resolução por meio de sítio eletrônico na internet, aplicativo ou outras plataformas de comunicação em rede."
            />
            , considera-se como “Correspondente Cambial” toda aquela Pessoa
            Jurídica{" "}
            <CustomTooltip
              title="¹⁴"
              text="Desde que amoldada ao teor do artigo 4º, de tal Resolução:
Art. 4º Podem ser contratados, na qualidade de correspondente:
I - as sociedades, os empresários e as associações definidos na Lei nº 10.406, de 10 de janeiro de 2002 (Código Civil);
II - os prestadores de serviços notariais e de registro de que trata a Lei nº 8.935, de 18 de novembro de 1994; e
III - as empresas públicas."
            />{" "}
            contratada pela OM DTVM, a fim de prestar serviços de atendimento
            aos seus Clientes e Usuários em toda a extensão do território
            pátrio.
          </p>
          <p>
            O Correspondente Cambial contratado pela OM DTVM está sujeito a
            todas as Políticas, Procedimentos e Manuais Internos da OM DTVM{" "}
            <CustomTooltip
              title="¹⁵"
              text="Como prevê o artigo 3º, da Resolução CMN nº 4.935/21:
Art. 3º O correspondente atua por conta e sob as diretrizes da instituição contratante, que assume inteira responsabilidade pelo atendimento prestado aos clientes e usuários por meio do contratado.
Parágrafo único.  Cabe à instituição contratante garantir a integridade, a confiabilidade, a segurança e o sigilo das transações realizadas por meio do contratado, bem como o cumprimento da legislação e da regulamentação relativas a essas transações."
            />{" "}
            <CustomTooltip
              title="¹⁶"
              text="Em especial, deve ser disponibiliza a base documental mínima adiante posta:
- Procedimento de Know Your Customer (“KYC”);
- Política de Prevenção à Lavagem de Dinheiro e Financiamento do Terrorismo (“PLD-FT”);
- Manual Operacional de Câmbio Turismo; e
- Manual Operacional de Câmbio Comercial."
            />
            , devendo haver, quando de sua contratação, a respectiva
            disponibilização e treinamento deste, a fim de que as normas lá
            previstas sejam estritamente cumpridas, sob pena de descontinuidade
            da operação desenvolvida em conjunto àquele Correspondente Cambial.
          </p>
        </section>

        <section className="mt-5 border p-5" id="sec9">
          <ul>
            <li className="fw-bolder text-decoration-underline text-uppercase mb-3 list-unstyled">
              9. Tipos e Funções de Correspondente Cambial
            </li>
          </ul>
          <p>
            Anteriormente ao início do relacionamento da OM DTVM, deve ser
            previamente alinhado com o Correspondente Cambial qual seria sua
            função exercida perante a Instituição, haja vista que subsiste
            restrição regulatória a tanto{" "}
            <CustomTooltip
              title="¹⁷"
              text=" Consonante artigo 13, da Resolução nº 4.935/21, a atuação do Correspondente Cambial deverá se restringir a:
Art. 13.  O atendimento prestado pelo correspondente em operações de câmbio deve ser contratualmente restrito às seguintes operações:
I - compra e venda de moeda estrangeira em espécie, cheque ou cheque de viagem, bem como carga de moeda estrangeira em cartão pré-pago;
II - execução ativa ou passiva de ordem de pagamento relativa a transferência unilateral do ou para o exterior; e
III - recepção e encaminhamento de propostas de operações de câmbio."
            />
            :
          </p>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontFamily: "Arial, sans-serif",
              fontSize: "14px",
            }}
          >
            <thead>
              <tr>
                <th
                  style={{
                    border: "1px solid #ccc",
                    padding: "10px",
                    backgroundColor: "#4a6900",
                    color: "#fff",
                    textAlign: "left",
                  }}
                >
                  TIPO DE CORRESPONDENTE
                </th>
                <th
                  style={{
                    border: "1px solid #ccc",
                    padding: "10px",
                    backgroundColor: "#4a6900",
                    color: "#fff",
                    textAlign: "left",
                  }}
                >
                  FUNÇÕES
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td
                  style={{
                    border: "1px solid #ccc",
                    padding: "10px",
                    verticalAlign: "top",
                  }}
                >
                  Correspondente Tipo I<br />
                  (artigo 13, I, da Resolução CMN nº 4.935/21)
                </td>
                <td
                  style={{
                    border: "1px solid #ccc",
                    padding: "10px",
                  }}
                >
                  Compra e venda de moeda estrangeira em espécie, cheque ou
                  cheque de viagem, bem como carga de moeda estrangeira em
                  cartão pré-pago.
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    border: "1px solid #ccc",
                    padding: "10px",
                    verticalAlign: "top",
                  }}
                >
                  Correspondente Tipo II
                  <br />
                  (artigo 13, II, da Resolução CMN nº 4.935/21)
                </td>
                <td
                  style={{
                    border: "1px solid #ccc",
                    padding: "10px",
                  }}
                >
                  Execução ativa ou passiva de ordem de pagamento relativa à
                  transferência unilateral do ou para o exterior; e
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    border: "1px solid #ccc",
                    padding: "10px",
                    verticalAlign: "top",
                  }}
                >
                  Correspondente Tipo III
                  <br />
                  (artigo 13, III, da Resolução CMN nº 4.935/21)
                </td>
                <td
                  style={{
                    border: "1px solid #ccc",
                    padding: "10px",
                  }}
                >
                  Recepção e encaminhamento de propostas de operações de câmbio.
                </td>
              </tr>
            </tbody>
          </table>
          <p>
            A OM DTVM e o Correspondente Cambial poderão alinhar que este
            exercera apenas uma, duas ou todas as funções declinadas no artigo
            13, da Resolução CMN nº 4.935/21, sendo sua classificação
            necessariamente sendo consonante àquela(s) função(ões) escolhida(s).
          </p>
        </section>

        <section className="mt-5 border p-5" id="sec10">
          <ul>
            <li className="fw-bolder text-decoration-underline text-uppercase mb-3 list-unstyled">
              10. Processo de Qualificação do Correspondente Cambial
            </li>
          </ul>
          <p>
            Seja qual Tipo Operacional daquele Correspondente Cambial seja
            estabelecido, este será submetido aos “Procedimentos
            Pré-Contratação” estabelecidos pela OM DTVM, os quais naturalmente
            antecedem qualquer assinatura formal do contrato porventura a ser
            formalizado{" "}
            <CustomTooltip
              text="Como determina o artigo 18, da Resolução CMN nº 4.935/21:
Art. 18.  As instituições mencionadas no art. 1º que mantiverem contratos de correspondente no País devem estabelecer e manter atualizada política de atuação e de contratação desses prestadores de serviços, prevendo, no mínimo:
I - critérios exigidos para contratação;"
              title="¹⁸"
            />
            .
          </p>
          <p>
            Nesse diapasão, como primeiro ato, sob pena de não prosseguimento do
            processo de contratação, o Potencial Correspondente Cambial deverá
            entregar a integralidade da base documental abaixo declinada:
          </p>
          <p className="text-decoration-underline">Documentos Cadastrais:</p>
          <p>I) Contrato Social;</p>
          <p>II) Comprovante de Regularidade Fiscal (ex: Cartão CNPJ);</p>
          <p>III) Comprovante de Endereço;</p>
          <p>
            IV) Documento de Identificação de seus Sócios, independentemente de
            participação societária; e
          </p>
          <p>
            V) Comprovante de Endereço dos Sócios, independentemente de
            participação societária.
          </p>
          <p className="text-decoration-underline">
            Documentos Financeiro-Contábeis:
          </p>
          <p>
            I) Balanço/Balancete e/ou Faturamento, necessariamente assinado pelo
            Contador e Sócio-Administrador;
          </p>
          <p>II) Escrituração Contábil Fiscal (“ECF”); e</p>
          <p>
            III) Última declaração de imposto de renda do Sócio com mais de 20%
            (vinte por cento das quotas sociais) e/ou sócio com poder de
            administração da Sociedade.
          </p>
          <p className="text-decoration-underline">
            Documentos Administrativos:
          </p>
          <p>I) Plano de Negócios;</p>
          <p>
            II) Para o Correspondente de Tipo I, a apresentação de SELO ABRACAM
            3.000, bem como de Certificação ABT-1 de seus
            gestores/administradores.{" "}
          </p>
          <p>
            {" "}
            Munida de toda a documentação retromencionada, como segundo ato, a
            OM DTVM inicia a verificação de autenticidade desta.
          </p>
          <p>
            A autenticidade documental ocorre através da utilização do sistema
            “PH3A”, o qual, por meio de API (Application Programming Interface -
            Interface de Programação de Aplicação), realiza instantânea consulta
            à diversas bases integralizadas (como Junta Comercial e Receita
            Federal) e, assim, gera um relatório que indica todos os dados
            vinculados àquela Pessoa Jurídica e seus respectivos Sócios.
          </p>
          <p>
            Feita a checagem documental, como terceiro ato, realiza-se a análise
            reputacional tanto da Pessoa Jurídica quanto de todos os seus
            Sócios, a qual é realizada através da utilização do Sistema RISC{" "}
            <CustomTooltip
              text="Plataforma de serviços web para pesquisa de dados reputacionais sobre pessoas físicas e jurídicas, capaz de centralizar as informações para tomada de decisão. As buscas são realizadas em centenas de fontes de informações incluindo, entre outras: Listas PEP e relacionados, Listas Sanções e Restritivas (nacionais e internacionais), Bureau Crédito, Órgãos Reguladores e Autarquias, Fontes Socioambientais. Através da consolidação de uma ampla gama de dados capturados em tempo real e critérios de risco pré-estabelecidos, a ferramenta entrega um relatório inteligente identificando o nível de risco reputacional da parte."
              title="¹⁹"
            />
          </p>
          <p>
            Tanto para o Potencial Correspondente Cambial quanto para seus
            Sócios, o Sistema RISC está parametrizado para aferir o risco
            inerente àqueles perfis <CustomTooltip title="²⁰" text="" />{" "}
            <CustomTooltip title="²¹" text="" />{" "}
            <CustomTooltip title="²³" text="" />
          </p>
          <p>
            Caso a análise reputacional reste integralmente positiva,
            prossegue-se ao quarto ato, em que é realizada minuciosa análise dos
            documentos financeiro-contábeis da Pessoa Jurídica e dos documentos
            fiscais de seus Sócios.{" "}
          </p>
          <p>
            Tal análise tem por escopo engendrar a constatação de lastro
            econômico daquele Correspondente, a fim de assegurar que a operação
            a eventualmente ser desenvolvida não esbarrará em limitações
            financeiras imprevistas e potencialmente periclitantes à sua
            continuidade.
          </p>
          <p>
            Nessa esteira, o Correspondente Cambial deverá apresentar reserva
            financeira ao menos 03 (três) vezes superior ao seu custo mínimo
            mensal, bem como apresentar faturamento bruto mensal nos últimos 06
            (seis) meses que ao menos reste equivalente ao montante de despesa
            bruta mensal.{" "}
          </p>
          <p>
            Isso realizado, como quinto ato, a fim de garantir a regularidade
            perante o Regimento da ABRACAM, a OM DTVM exige que o Correspondente
            Cambial de Tipo I apresente o Selo de Conformidade ABRACAM 3.000,
            bem como que seus gestores/administradores apresentem certificação
            ABT-1.
          </p>
          <p>
            Além de tal documentação, o Correspondente Cambial deverá apresentar
            um “Plano de Negócios” relativo ao empreendimento a ser viabilizado
            com a OM DTVM, o qual passará pelo discricionário crivo do Corpo
            Diretivo da OM DTVM previamente à formalização do Contrato.
          </p>

          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontFamily: "Arial, sans-serif",
              fontSize: "14px",
            }}
          >
            <thead>
              <tr>
                <th
                  style={{
                    border: "1px solid #999",
                    padding: "8px",
                    backgroundColor: "#ccc",
                    color: "#003b3f",
                    textAlign: "left",
                  }}
                >
                  DESCRIÇÃO DA PONTUAÇÃO
                </th>
                <th
                  style={{
                    border: "1px solid #999",
                    padding: "8px",
                    backgroundColor: "#ccc",
                    color: "#003b3f",
                    textAlign: "left",
                  }}
                >
                  PONTUAÇÃO
                </th>
              </tr>
            </thead>
            <tbody>
              {[
                ["LISTA CSNU", 30],
                ["CPF/CNPJ INATIVO", 30],
                ["PEP – PESSOA EXPOSTA POLITICAMENTE", 10],
                ["LISTA DE SANÇÕES", 10],
                ["CVM – PROCESSOS SANCIONADORES", 10],
                ["ANTECEDENTE CRIMINAL", 10],
                ["CIDADE FRONTEIRA", 10],
                ["INEXISTÊNCIA DE BENEFICIÁRIO FINAL", 10],
                ["MULTAS AMBIENTAIS", 5],
                ["LISTA RESTRITIVA", 5],
                ["PROCESSOS JUDICIAIS", 5],
                ["MÍDIA NEGATIVA", 5],
              ].map(([descricao, pontuacao], index) => (
                <tr key={index}>
                  <td
                    style={{
                      border: "1px solid #999",
                      padding: "8px",
                    }}
                  >
                    {descricao}
                  </td>
                  <td
                    style={{
                      border: "1px solid #999",
                      padding: "8px",
                    }}
                  >
                    {pontuacao}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <p>(Extraído do Procedimento de KYP da OM)</p>

          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontFamily: "Arial, sans-serif",
              fontSize: "14px",
            }}
          >
            <thead>
              <tr>
                <th
                  style={{
                    border: "1px solid #999",
                    padding: "8px",
                    backgroundColor: "#ccc",
                    color: "#003b3f",
                    textAlign: "left",
                  }}
                >
                  RISCO
                </th>
                <th
                  style={{
                    border: "1px solid #999",
                    padding: "8px",
                    backgroundColor: "#ccc",
                    color: "#003b3f",
                    textAlign: "left",
                  }}
                >
                  ESCALA DE PONTOS
                </th>
              </tr>
            </thead>
            <tbody>
              {[
                ["INACEITÁVEL", "30 ATÉ 99"],
                ["ALTO", "10 ATÉ 29"],
                ["MÉDIO", "05 ATÉ 09"],
                ["BAIXO", "00 ATÉ 04"],
              ].map(([risco, escala], index) => (
                <tr key={index}>
                  <td
                    style={{
                      border: "1px solid #999",
                      padding: "8px",
                    }}
                  >
                    {risco}
                  </td>
                  <td
                    style={{
                      border: "1px solid #999",
                      padding: "8px",
                    }}
                  >
                    {escala}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <p>(Extraído do Procedimento de KYP da OM)</p>

          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontFamily: "Arial, sans-serif",
              fontSize: "14px",
            }}
          >
            <tbody>
              {[
                ["CORRESPONDENTE CAMBIAL: TIPO 3", 1],
                ["CORRESPONDENTE CAMBIAL: TIPO 2", 5],
                ["CORRESPONDENTE CAMBIAL: TIPO 1", 10],
              ].map(([descricao, pontos], index) => (
                <tr key={index}>
                  <td
                    style={{
                      border: "1px solid #999",
                      padding: "8px",
                    }}
                  >
                    {descricao}
                  </td>
                  <td
                    style={{
                      border: "1px solid #999",
                      padding: "8px",
                      textAlign: "right",
                    }}
                  >
                    {pontos}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <p>(Extraído do Procedimento de KYP da OM)</p>
          <p>
            Por arremate, como sexto ato, a OM DTVM realiza visita presencial ao
            estabelecimento do Correspondente Cambial, a fim de conferir suas
            dependências e peculiaridades, sendo lavrado um “Relatório de
            Visita” em tal oportunidade.{" "}
          </p>
          <p>
            Apresentada toda a documentação acima narrada, sendo esta autêntica
            e, ainda, estejam os Perfis do Correspondente Cambial e de seus
            respectivos Sócios dentro da parametrização de risco estabelecida, a
            OM DTVM procede à formalização do “Contrato de Prestação de Serviço
            de Correspondente Cambial”, o qual observará os requisitos
            declinados no tópico seguinte desta Política.
          </p>
        </section>

        <section className="mt-5 border p-5" id="sec11">
          <ul>
            <li className="fw-bolder text-decoration-underline text-uppercase mb-3 list-unstyled">
              11. RISCO OPERACIONAL E REANÁLISE DO CORRESPONDENTE CAMBIAL
            </li>
          </ul>
          <p>
            Como mencionado na Referência 22 desta Política e bem explorado em
            seu Procedimento de KYP, a OM DTVM realiza a aferição de Risco de
            seus Correspondentes Cambiais de forma bastante objetiva, como
            adiante declinado.
          </p>

          <p className="text-decoration-underline">
            <b>CORRESPONDENTE CAMBIAL DE TIPO I:</b>
          </p>
          <p>
            O Correspondente Cambial de Tipo 1 foi atribuído como de alto risco
            por realizar operações de compra e venda de moeda estrangeira. Essas
            operações, ainda que geralmente envolvem clientes pessoa física, por
            terem sua rastreabilidade dificultada pelo uso de cédulas, implica
            em maior risco operacional, ainda que seja este mitigado à luz das
            Políticas da OM DTVM (PLD-FT, KYC e Política de Correspondente
            Cambial).
          </p>

          <p className="text-decoration-underline">
            <b> CORRESPONDENTE CAMBIAL DE TIPO II:</b>
          </p>
          <p>
            {" "}
            O Correspondente Cambial de Tipo 2 foi atribuído como de médio risco
            por estar autorizado a realizar operações de câmbio relacionadas a
            transferências unilaterais, como envio e recebimento de recursos do
            exterior (remessas pessoais, ordens de pagamento, entre outras).
            Além disso, realiza operações de câmbio mais estruturadas,
            geralmente envolvendo pessoas jurídicas e valores mais elevados,
            como investimentos e manutenção de residentes. Embora essas
            operações tenham maior rastreabilidade e documentação formal, o
            risco persiste devido à complexidade das transações internacionais,
            à possibilidade de estruturas societárias opacas e à exposição a
            diferentes jurisdições, ainda que sejam tais práticas sejam obstados
            pelas Políticas da OM DTVM (PLD-FT, KYC e Política de Correspondente
            Cambial). Tal molde operacional amplia o risco de lavagem de
            dinheiro, financiamento ao terrorismo e uso indevido do sistema
            financeiro para fins ilícitos, especialmente em casos de
            identificação precária do remetente ou destinatário, ou ainda de
            fracionamento de valores para escapar de controles regulatórios,
            mesmo que sejam tais práticas sejam obstados pelas Políticas da OM
            DTVM (PLD-FT, KYC e Política de Correspondente Cambial).{" "}
          </p>

          <p className="text-decoration-underline">
            <b> CORRESPONDENTE CAMBIAL DE TIPO III:</b>
          </p>
          <p>
            O Correspondente Cambial de Tipo 3 foi atribuído como de baixo risco
            por apenas realizar a indicação de operações cambiais à OM DTVM, as
            quais serão operacionalizadas pela própria OM DTVM, de modo a
            apresentar risco minorado por tal razão.
          </p>
          <p>
            Fixado o risco para cada Tipo de Correspondente Cambial, a OM DTVM
            particularmente parametriza as consequências operacionais deste,
            especialmente no que tange a revisão documental e reputacional:
          </p>

          <p className="text-decoration-underline">
            <b> CORRESPONDENTE CAMBIAL DE TIPO III – RISCO BAIXO:</b>
          </p>
          <p>
            Para Correspondentes Cambiais de Tipo III, por serem enquadrados
            como “Risco Baixo”, o período de atualização deve obedecer a métrica
            de 18 (dezoito) meses ao máximo, podendo ser necessário o
            encurtamento do prazo se determinado por Órgão Regulatório.
          </p>
          <p>
            A atualização consiste em nova disponibilização da integralidade da
            base documental disponibilizada quando do “Procedimento de
            Pré-Contratação”, os quais igualmente passarão pela mesma análise de
            autenticidade e viabilidade.{" "}
          </p>
          <p>
            Adicionalmente, realizar-se-á nova análise reputacional do
            Correspondente Cambial e de seus Sócios, a fim de garantir a
            permanência de status de risco inferior.
          </p>

          <p className="text-decoration-underline">
            <b> CORRESPONDENTE CAMBIAL DE TIPO II – RISCO MÉDIO:</b>
          </p>
          <p>
            Para Correspondentes Cambiais de Tipo II, por serem enquadrados como
            “Risco Médio”, o período de atualização deve obedecer a métrica de
            12 (doze) meses ao máximo, podendo ser necessário o encurtamento do
            prazo se determinado por Órgão Regulatório.
          </p>
          <p>
            A atualização consiste em nova disponibilização da integralidade da
            base documental disponibilizada quando do “Procedimento de
            Pré-Contratação”, os quais igualmente passarão pela mesma análise de
            autenticidade e viabilidade.{" "}
          </p>
          <p>
            A atualização consiste em nova disponibilização da integralidade da
            base documental disponibilizada quando do “Procedimento de
            Pré-Contratação”, os quais igualmente passarão pela mesma análise de
            autenticidade e viabilidade.{" "}
          </p>

          <p className="text-decoration-underline">
            <b> CORRESPONDENTE CAMBIAL DE TIPO III – RISCO BAIXO:</b>
          </p>
          <p>
            Para Correspondentes Cambiais de Tipo III, por serem enquadrados
            como “Risco Baixo”, o período de atualização deve obedecer a métrica
            de 18 (dezoito) meses ao máximo, podendo ser necessário o
            encurtamento do prazo se determinado por Órgão Regulatório.
          </p>
          <p>
            A atualização consiste em nova disponibilização da integralidade da
            base documental disponibilizada quando do “Procedimento de
            Pré-Contratação”, os quais igualmente passarão pela mesma análise de
            autenticidade e viabilidade.{" "}
          </p>
          <p>
            Adicionalmente, realizar-se-á nova análise reputacional do
            Correspondente Cambial e de seus Sócios, a fim de garantir a
            permanência de status de risco inferior.
          </p>

          <p className="text-decoration-underline">
            <b> CORRESPONDENTE CAMBIAL DE TIPO II – RISCO MÉDIO:</b>
          </p>
          <p>
            Para Correspondentes Cambiais de Tipo II, por serem enquadrados como
            “Risco Médio”, o período de atualização deve obedecer a métrica de
            12 (doze) meses ao máximo, podendo ser necessário o encurtamento do
            prazo se determinado por Órgão Regulatório.
          </p>
          <p>
            A atualização consiste em nova disponibilização da integralidade da
            base documental disponibilizada quando do “Procedimento de
            Pré-Contratação”, os quais igualmente passarão pela mesma análise de
            autenticidade e viabilidade.{" "}
          </p>
          <p>
            A atualização consiste em nova disponibilização da integralidade da
            base documental disponibilizada quando do “Procedimento de
            Pré-Contratação”, os quais igualmente passarão pela mesma análise de
            autenticidade e viabilidade. A atualização consiste em nova
            disponibilização da integralidade da base documental disponibilizada
            quando do “Procedimento de Pré-Contratação”, os quais igualmente
            passarão pela mesma análise de autenticidade e viabilidade.{" "}
          </p>

          <p className="text-decoration-underline">
            <b> CORRESPONDENTE CAMBIAL DE TIPO I – RISCO ALTO:</b>
          </p>
          <p>
            Em atendimento ao disposto no art. 10, § 3º da Circular nº 3.978/20
            do Banco Central do Brasil, a OM DTVM estabelece e implementa
            diligências adicionais para o Correspondente Cambial de Tipo I,
            visto que enquadrados como de “Risco Alto”, sendo tais:
          </p>

          <p className="text-decoration-underline">MEDIDAS EXCEPCIONAIS:</p>
          <p>
            Em atendimento ao disposto no art. 10, § 3º da Circular nº 3.978/20
            do Banco Central do Brasil, a OM DTVM estabelece e implementa
            diligências adicionais para o Correspondente Cambial de Tipo I,
            visto que enquadrados como de “Risco Alto”, sendo tais:
          </p>

          <p>
            <b>I) </b> Realização de Due Diligence aprofundada (Enhanced Due
            Diligence – EDD), com análise documental detalhada e validação de
            informações com fontes independentes.
          </p>
          <p>
            <b>II) </b> Solicitação de documentação complementar, como:
          </p>
          <ul>
            <li>Contratos sociais atualizados e alterações contratuais;</li>
            <li>Comprovantes de endereço e atividade econômica;</li>
            <li>Demonstrações financeiras auditadas;</li>
            <li>
              Certidões negativas criminais e fiscais dos sócios e
              administradores.
            </li>
          </ul>
          <p>
            <b>III) </b> Entrevista direta com representantes legais ou
            beneficiários finais (se necessário), a fim de esclarecer estruturas
            societárias complexas, origens de recursos e objetivos da relação
            comercial.
          </p>
          <p>
            <b>IV) </b> Consulta ativa em listas internacionais de sanções e
            PEPs (Pessoas Politicamente Expostas), a qual deverá ser realizada
            através da inclusão destes no sistema E-GUARDIAN, a fim de
            monitoramento contínuo de suas atividades.
          </p>
          <p>
            <b>V) </b> Avaliação da exposição ao risco jurisdicional, em casos
            de atuação ou sede em países classificados como de alto risco ou com
            deficiências estratégicas em PLD/FT.{" "}
          </p>
          <p>
            <b>VI) </b> Inclusão de cláusulas contratuais específicas de
            compliance, prevendo:
          </p>
          <ul>
            <li>Obrigatoriedade de manutenção de programa de integridade;</li>
            <li>Cooperação em eventuais investigações internas;</li>
            <li>Regras anticorrupção; e</li>
            <li>Rescisão contratual por descumprimento de normas de PLD/FT.</li>
          </ul>
          <p>
            <b>VII) </b> Submissão à unanime aprovação da contratação/renovação
            pelo Departamento de Compliance e Corpo Diretor da OM DTVM.
          </p>

          <p>
            Essas medidas visam assegurar que a contratação de Correspondentes
            Cambiais de Tipo I pela OM DTVM esteja alinhada com os princípios de
            integridade, transparência e prevenção a ilícitos, conforme os
            padrões regulatórios e de boas práticas do mercado.
          </p>

          <p>
            Além disso, para Correspondentes Cambiais de Tipo I, por serem
            enquadrados como “Risco Alto”, o período de atualização deve
            obedecer a métrica de 06 (seis) meses ao máximo, podendo ser
            necessário o encurtamento do prazo se determinado por Órgão
            Regulatório.
          </p>

          <p>
            A atualização consiste em nova disponibilização da integralidade da
            base documental disponibilizada quando do “Procedimento de
            Pré-Contratação”, os quais igualmente passarão pela mesma análise de
            autenticidade e viabilidade.
          </p>
          <p>
            Adicionalmente, realizar-se-á nova análise reputacional do
            Correspondente Cambial e de seus Sócios, a fim de garantir a
            permanência do status de risco.
          </p>
        </section>

        <section className="mt-5 border p-5" id="sec12">
          <ul>
            <li className="fw-bolder text-decoration-underline text-uppercase mb-3 list-unstyled">
              12. CONTRATO COM O CORRESPONDENTE CAMBIAL
            </li>
          </ul>
          <p>
            Consonante disposto no artigo 14, da Resolução CMN nº 4.935/21, o
            “Contrato de Prestação de Serviços de Correspondente Cambial” a ser
            firmado entre a OM DTVM e o Correspondente Cambial deve,
            necessariamente, conter:
          </p>
          <ul>
            <li>Clareza e objetividade;</li>
            <li>Discriminação dos serviços prestados;</li>
            <li>Definição de responsabilidades;</li>
            <li>Condições de rescisão;</li>
            <li>Obrigações de confidencialidade;</li>
            <li>Condições de remuneração;</li>
            <li>Previsão de auditoria e supervisão; e</li>
            <li>Disposições sobre a legislação aplicável.</li>
          </ul>
          <p>
            Ademais, o contrato deve prever cláusulas que garantam a
            conformidade com as normas de prevenção à lavagem de dinheiro e
            financiamento do terrorismo, bem como a possibilidade de rescisão
            imediata em caso de descumprimento das obrigações contratuais.
          </p>

          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontFamily: "Arial, sans-serif",
              fontSize: "14px",
            }}
          >
            <thead>
              <tr>
                <th
                  style={{
                    border: "1px solid #999",
                    padding: "8px",
                    backgroundColor: "#333",
                    color: "#fff",
                    textAlign: "center",
                  }}
                >
                  Nº
                </th>
                <th
                  style={{
                    border: "1px solid #999",
                    padding: "8px",
                    backgroundColor: "#333",
                    color: "#fff",
                  }}
                >
                  REQUISITOS CUMULATIVOS AOS CORRESPONDENTES DE TIPO I, II E III
                </th>
              </tr>
            </thead>
            <tbody>
              {[
                "Exigência de manutenção de relacionamento contratual/empregatício com os funcionários envolvidos no atendimento ao Cliente.",
                "Vedação da utilização de logomarcas e/ou atributos que sejam similares àqueles adotados pela OM DTVM em suas agências, postos de atendimento, site eletrônico na internet, aplicativo ou outras plataformas de comunicação em rede.",
                "Divulgação ao público, por meio de seu site eletrônico, aplicativo e painéis, em local visível, de sua condição de prestador de serviços da OM DTVM.",
                "Obrigatoriedade de que o Correspondente Cambial, no exercício da intermediação com clientes, apresente, de forma clara e acessível, os custos e as condições aplicáveis à contratação dos produtos e serviços ofertados pela OM DTVM referidos nos incisos I, V e VII do art. 12, da Resolução CMN nº 4.935/21.",
                "Realização de acertos financeiros entre a instituição contratante e o correspondente no prazo máximo de dois dias úteis.",
                "Observância, pelo Correspondente, dos padrões, normas operacionais e tabelas definidas pela OM DTVM, inclusive quanto à fixação de tarifas, taxas de juros, taxas de câmbio, cálculos de Custo Efetivo Total (CET) ou Valor Efetivo Total (VET) e quaisquer valores cobrados ou pagos pelo cliente no âmbito das operações.",
                "Vedação ao Correspondente de emitir, em benefício próprio, instrumentos de pagamento ou títulos vinculados às operações realizadas, bem como de auferir, direta ou indiretamente, valores relativos aos produtos e serviços ofertados pela OM DTVM.",
                "Vedação de que o correspondente antecipe recursos ao cliente com base em valores a serem futuramente liberados pela OM DTVM.",
                "Vedação à prestação de garantias, inclusive na forma de coobrigação, pelo Correspondente, nas operações objeto do contrato.",
                "Responsabilidade do Correspondente pelo atendimento inicial ao cliente e aos respectivos esclarecimentos e demandas de esclarecimento, documentação, comprovações, reclamações ou correlatos, com encaminhamento imediato à OM contratante, no máximo, até o segundo atendimento.",
                "Franquia de acesso ao Banco Central do Brasil aos contratos firmados sob a égide da Resolução CMN nº 4.935/21, bem como à documentação relativa aos produtos e serviços ofertados, e às instalações e registros do correspondente, inclusive os constitutivos cadastrais e licenças exigidas pela legislação.",
                "Responsabilidade por despesas administrativas pela OM DTVM decorrentes de eventual atuação do Banco Central do Brasil, nos termos do art. 18, da Resolução CMN nº 4.935/21, em face do Correspondente.",
                "Previsão expressa no contrato de que a atividade de contratação é realizada pelo OM, consoante o disposto no art. 18, da Resolução CMN nº 4.935/21, vedada a sua delegação ao Correspondente.",
                "Previsão expressa de que o Correspondente quanto ao seu conhecimento de que a realização, por sua própria conta, de operações privativas de instituições financeiras é vedada, sendo, nesse caso, sujeita à infrações previstas nas Leis nº 7.492/1986 e nº 13.506/2017.",
              ].map((descricao, index) => (
                <tr key={index}>
                  <td
                    style={{
                      border: "1px solid #999",
                      padding: "6px",
                      textAlign: "center",
                      verticalAlign: "top",
                      fontWeight: "bold",
                    }}
                  >
                    {index + 1}º
                  </td>
                  <td
                    style={{
                      border: "1px solid #999",
                      padding: "8px",
                      textAlign: "justify",
                    }}
                  >
                    {descricao}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <table
            style={{
              marginTop: "20px",
              width: "100%",
              borderCollapse: "collapse",
              fontFamily: "Arial, sans-serif",
              fontSize: "14px",
            }}
          >
            <thead>
              <tr>
                <th
                  style={{
                    border: "1px solid #999",
                    padding: "8px",
                    backgroundColor: "#336633",
                    color: "#fff",
                    textAlign: "center",
                  }}
                >
                  Nº
                </th>
                <th
                  style={{
                    border: "1px solid #999",
                    padding: "8px",
                    backgroundColor: "#336633",
                    color: "#fff",
                  }}
                >
                  REQUISITOS EXCLUSIVOS AO CORRESPONDENTE DE TIPO I
                </th>
              </tr>
            </thead>
            <tbody>
              {[
                "Limitação ao valor de US$ 3.000,00 (três mil dólares) ou seu equivalente por operação;",
                "Na compra ou venda de moeda estrangeira em espécie, com o contravalor também em espécie, a limitação de US$ 1.000,00 (mil dólares);",
                'Obrigatoriedade de apresentar o Valor Efetivo Total ("VET") em reais da operação ao Cliente;',
                "Obrigatoriedade de apresentar a taxa de câmbio, tributos incidentes e tarifas ao Cliente;",
                "Obrigatoriedade de apresentar o comprovante da transação ao Cliente;",
                "Obrigatoriedade de o comprovante identificar: (I) a OM DTVM; (II) o Correspondente Cambial; (III) o Cliente, (IV) a moeda estrangeira; (V) a taxa de câmbio; (VI) os valores em moeda estrangeira e em moeda nacional; e (VII) o VET;",
                "Observância das resoluções regulatórias incidentes sobre o mercado de câmbio;",
                "Cláusula de Exclusividade na Prestação de Serviços;",
              ].map((texto, i) => (
                <tr key={i}>
                  <td
                    style={{
                      border: "1px solid #999",
                      padding: "6px",
                      textAlign: "center",
                      fontWeight: "bold",
                      verticalAlign: "top",
                    }}
                  >
                    {i + 1}º
                  </td>
                  <td
                    style={{
                      border: "1px solid #999",
                      padding: "8px",
                      textAlign: "justify",
                    }}
                  >
                    {texto}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <table
            style={{
              marginTop: "20px",
              width: "100%",
              borderCollapse: "collapse",
              fontFamily: "Arial, sans-serif",
              fontSize: "14px",
            }}
          >
            <thead>
              <tr>
                <th
                  style={{
                    border: "1px solid #999",
                    padding: "8px",
                    backgroundColor: "#666600",
                    color: "#fff",
                    textAlign: "center",
                  }}
                >
                  Nº
                </th>
                <th
                  style={{
                    border: "1px solid #999",
                    padding: "8px",
                    backgroundColor: "#666600",
                    color: "#fff",
                  }}
                >
                  REQUISITO EXCLUSIVO AO CORRESPONDENTE DE TIPO II
                </th>
              </tr>
            </thead>
            <tbody>
              {[
                "Obrigatoriedade de apresentar o Valor Efetivo Total (“VET”) em reais da operação ao Cliente;",
                "Obrigatoriedade de apresentar a taxa de câmbio, tributos incidentes e tarifas ao Cliente;",
                "Obrigatoriedade de apresentar o comprovante da transação ao Cliente;",
                "Obrigatoriedade de o comprovante identificar: (I) a OM DTVM; (II) o Correspondente Cambial; (III) o Cliente, (IV) a moeda estrangeira; (V) a taxa de câmbio; (VI) os valores em moeda estrangeira e em moeda nacional; e (VII) o VET;",
                "Nas operações de remessa e/ou recebimento de valores para/do exterior, a identificação do remetente e do recebedor da transação;",
                "Observância das resoluções regulatórias incidentes sobre o mercado de câmbio.",
              ].map((item, idx) => (
                <tr key={idx}>
                  <td
                    style={{
                      border: "1px solid #999",
                      padding: "6px",
                      textAlign: "center",
                      fontWeight: "bold",
                      verticalAlign: "top",
                    }}
                  >
                    {idx + 1}º
                  </td>
                  <td
                    style={{
                      border: "1px solid #999",
                      padding: "8px",
                      textAlign: "justify",
                    }}
                  >
                    {item}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <p>
            A OM DTVM pode, ainda, negociar condições contratuais da forma que
            julgar mais afetuosa àquilo que pretende com a contratação daquele
            Correspondente Cambial, contudo, a base mínima de itens contratuais
            acima narrada impreterivelmente deverá ser preservada em sua
            integralidade, sob pena de sua não pactuação.
          </p>
          <p>
            Estando o Contrato assinado por ambas as Partes, a OM DTVM realizará
            o cadastro do Correspondente Cambial perante o UNICAD e seu Sistema
            Interno (“TravelCash”), bem como promoverá a menção deste em seu
            sítio eletrônico e, estando tais etapas superadas, o Correspondente
            Cambial poderá começar a operar.
          </p>
        </section>

        <section className="mt-5 border p-5" id="sec13">
          <ul>
            <li className="fw-bolder text-decoration-underline text-uppercase mb-3 list-unstyled">
              13. ACOMPANHAMENTO DA ATIVIDADE NEGOCIAL DO CORRESPONDENTE
            </li>
          </ul>
          <p>
            No curso de desenvolvimento do “Contrato de Prestação de Serviços de
            Correspondente Cambial”, a OM DTVM realiza contínuo acompanhamento
            das atividades de seu Correspondente Cambial, através de:
          </p>
          <p>
            O monitoramento inclui a análise de transações realizadas pelos
            Correspondentes Cambiais, bem como a verificação da manutenção das
            condições contratuais e regulamentares.
          </p>
          <p>
            Além disso, a OM DTVM implementa mecanismos de alerta para
            identificar atividades suspeitas ou não conformidades, permitindo a
            adoção de medidas corretivas quando necessário.
          </p>

          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontFamily: "Arial, sans-serif",
              fontSize: "14px",
            }}
          >
            <thead>
              <tr>
                <th
                  style={{
                    border: "1px solid #999",
                    padding: "8px",
                    backgroundColor: "#003300",
                    color: "#fff",
                    textAlign: "center",
                  }}
                >
                  Nº
                </th>
                <th
                  style={{
                    border: "1px solid #999",
                    padding: "8px",
                    backgroundColor: "#003300",
                    color: "#fff",
                  }}
                >
                  ATOS DE ACOMPANHAMENTO PELA OM DTVM
                </th>
                <th
                  style={{
                    border: "1px solid #999",
                    padding: "8px",
                    backgroundColor: "#003300",
                    color: "#fff",
                    textAlign: "center",
                  }}
                >
                  PERIODICIDADE
                </th>
              </tr>
            </thead>
            <tbody>
              {[
                [
                  "Visita Presencial ao Estabelecimento do Correspondente",
                  "Anual",
                ],
                [
                  "Auditoria via Câmera/Presencial do caixa financeiro.",
                  "Contínuo",
                ],
                [
                  "Reunião para Alinhamento de Expectativas e/ou Melhorias",
                  "Anual",
                ],
                [
                  "Relatório de Desempenho Econômico do Correspondente Cambial",
                  "Mensal",
                ],
                ["Relatório de Cumprimento Contratual", "Mensal"],
              ].map(([ato, periodicidade], index) => (
                <tr key={index}>
                  <td
                    style={{
                      border: "1px solid #999",
                      padding: "6px",
                      textAlign: "center",
                      fontWeight: "bold",
                    }}
                  >
                    {index + 1}º
                  </td>
                  <td
                    style={{
                      border: "1px solid #999",
                      padding: "8px",
                    }}
                  >
                    {ato}
                  </td>
                  <td
                    style={{
                      border: "1px solid #999",
                      padding: "8px",
                      textAlign: "center",
                    }}
                  >
                    {periodicidade}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <p>Por meio dos cinco atos acima listados, a OM DTVM realiza aprofundado acompanhamento das atividades de seu Correspondente Cambial, os quais não tem apenas o fito de assegurar a integralidade do cumprimento daquilo pactuado entre as Partes, mas, também, de assegurar a legalidade da operação e a viabilidade econômica do prosseguimento das atividades.</p>
        </section>
        <section className="mt-5 border p-5" id="sec14">
          <ul>
            <li className="fw-bolder text-decoration-underline text-uppercase mb-3 list-unstyled">
              14. GUARDA DE DOCUMENTOS
            </li>
          </ul>
          <p>
          A <b>OM DTVM</b> garante a guarda de todas as informações de todas as informações relacionadas com suas operações de câmbio pelo prazo de 10 (dez) anos.
          </p>

        </section>
        <section className="mt-5 border p-5" id="sec15">
          <ul>
            <li className="fw-bolder text-decoration-underline text-uppercase mb-3 list-unstyled">
              15. SANÇÕES ADMINISTRATIVAS
            </li>
          </ul>
          <p>
            A <b>OM DTVM,</b> com o escopo de preservar a legalidade e assertividade de suas operações, desenvolveu um protocolo de sanções e penalidades a serem aplicadas em face de qualquer participante de sua operação, em caso de descumprimento das regulações do Banco Central do Brasil ou de qualquer outra legislação aplicável.
          </p>
          <p>
          Nessa toada, no evento de ser cometida alguma irregularidade, ao tomar ciência, a  <b>OM DTVM</b>   instaurará um procedimento interno para apuração dos fatos, do que decorrerá a constatação de eventual ocorrência e gravidade da conduta.

          </p>
          <p>Verificada a ocorrência e apurada a gravidade, a  <b>OM DTVM </b> aplicará as sanções proporcionalmente, as quais são constituídas por advertência por ofício, advertência formal, suspensão temporária do contrato ou rescisão contratual motivada, sem prejuízo da aplicação de multas contratuais por tal razão. </p>
        </section>
      </section>
    </article>
  );
}

const CustomTooltip = (props: { title: string; text: string }) => {
  return (
    <>
      <Tooltip title={props.text} placement="top-start">
        <sup>
          <Button style={{ margin: 0, padding: 0, minWidth: "0px" }}>
            {props.title}
          </Button>
        </sup>
      </Tooltip>
    </>
  );
};
